import { observer } from 'mobx-react-lite';

import { useStore } from 'src/store';
import { WellInfoSidebarStore } from 'src/store/well-info-sidebar';

import type { InfoSidebarTab } from '../entities/info-sidebar-tab.entity';
import { TabWithColumns } from '../entities/tab-with-columns-entities/tab-with-columns.entity';
import { TabWithPads } from '../entities/tab-with-pads-entities/tab-with-pads.entity';
import { TabWithStages } from '../entities/tab-with-stages-entities/tab-with-stages.entity';
import { TabWithWells } from '../entities/tab-with-wells-entities/tab-with-wells.entity';
import type { Well } from '../entities/tab-with-wells-entities/well.entity';
import type { GraphInfoSidebarStore } from '../graph-info-sidebar';

import { BasicData } from './basic-data';
import { GeologicalLoadTab } from './geological-load-tab';
import styles from './info-sidebar-tab-component.module.scss';
import { PadWells } from './pad-wells/pad-wells';
import { Pads } from './pads';
import { WellStages } from './well-stages';

type Props = {
  activeTab: InfoSidebarTab | undefined | null;
  store: GraphInfoSidebarStore;
  onWellClick?: (wellId: number) => void;
  onPadClick?(padId: number): void;
  onWellAdd?: VoidFunction;
  onEditingWellClick?: (wellId: number) => void;
  onToggleSlider?: (well: Well, isSliderUsing: boolean) => Promise<void>;
};

export const InfoSidebarTabContent = observer(function InfoSidebarTabContent({
  activeTab,
  store,
  onWellClick,
  onPadClick,
  onWellAdd,
  onEditingWellClick,
  onToggleSlider,
}: Props) {
  const { editing } = useStore();

  if (activeTab instanceof TabWithColumns && !!activeTab.columns.length) {
    if (store instanceof WellInfoSidebarStore) {
      if (activeTab.fieldId === 'geologicalLoad') {
        return (
          <GeologicalLoadTab
            rigOperations={store.rigOperations}
            geoTaskGeoLoad={store.geoTaskGeoLoad}
            geoLoadRigOperations={store.geologicalLoadRigOperations}
            geologicalLoadViewModel={store.geologicalLoadViewModel}
          />
        );
      }
    }

    return <BasicData columns={activeTab.columns} />;
  }
  if (activeTab instanceof TabWithStages && !!activeTab.rigOperations.length) {
    return <WellStages rigOperations={activeTab.rigOperations} />;
  }
  if (activeTab instanceof TabWithWells && !!activeTab.wells.length) {
    return (
      <div className={styles.TabWithWellsPadWellsWrapper}>
        <PadWells
          wells={activeTab.wells}
          wellCardClassName={styles.wellCard}
          onWellClick={onWellClick}
          onToggleSlider={onToggleSlider}
        />
      </div>
    );
  }
  if (activeTab instanceof TabWithPads && !!activeTab.pads.length) {
    return (
      <Pads
        pads={activeTab.pads}
        isEditing={editing.isEditing}
        onWellClick={onWellClick}
        onPadClick={onPadClick}
        onWellAdd={onWellAdd}
        onEditingWellClick={onEditingWellClick}
      />
    );
  }

  return null;
});
